document.addEventListener('DOMContentLoaded', function() {

  // ── DATI FRAGRANZE ──
  // Struttura: [nome, url, ufi3, ufi6, ufi8, ufi10]
  // true  = UFI obbligatorio
  // false = UFI non richiesto
  // null  = in aggiornamento (—)
  const fragranze = [
    ["Amber & Woods", "/products/amber-woods", false, false, false, false],
    ["Apple & Cinnamon (Mela & Cannella)", "/products/apple-cinnamon", true, true, true, true],
    ["Bergamot (Bergamotto)", "/products/bergamot", false, false, false, true],
    ["Bosco Incantato", "/products/bosco-incantato", false, false, false, false],
    ["Christmas Punch", "/products/christmas-punch", true, true, true, true],
    ["Clean Cotton", "/products/clean-cotton", false, false, false, true],
    ["Rose Delicate", "/products/rose-delicate", false, false, false, false],
    ["Divine Red", "/products/divine-red", false, false, false, false],
    ["Egyptian Amber", "/products/fragranza-per-candele-egyptian-amber-per-soia-e-paraffina", false, false, false, false],
    ["Fairy Cake", "/products/fairy-cake", null, null, null, null],
    ["Fig & Blueberry (Fico & Mirtillo)", "/products/fig-blueberry", null, null, null, null],
    ["Forest After The Rain", "/products/forest-after-the-rain", null, null, null, null],
    ["Fragola e Panna", "/products/fragola-e-panna", null, null, null, null],
    ["Gingerbread (Pan di Zenzero)", "/products/gingerbread", null, null, null, null],
    ["Gipsy Chipre", "/products/fragranza-per-candele-gipsy-chipre-per-soia-e-paraffina", null, null, null, null],
    ["Golden & Woods", "/products/golden-woods", null, null, null, null],
    ["Hot Chocolate (Cioccolata Calda)", "/products/hot-chocolate", null, null, null, null],
    ["Kumquat & Pompelmo Rosa", "/products/kumquat-pink-grapefruit", null, null, null, null],
    ["Lemon Buds", "/products/lemon-buds", null, null, null, null],
    ["Verbena (Erba Cedrina)", "/products/lemon-verbena", true, true, true, true],
    ["Luxor", "/products/luxor", null, null, null, null],
    ["Mandarin & Cinnamon (Mandarino & Cannella)", "/products/mandarin-cinnamon", null, null, null, null],
    ["Orange & Cinnamon (Arancia & Cannella)", "/products/orange-cinnamon", null, null, null, null],
    ["Orange, Chocolate & Rum", "/products/orange-chocolate-rum", null, null, null, null],
    ["Oriental Vibes", "/products/oriental-vibes", null, null, null, null],
    ["Pandoro", "/products/pandoro", null, null, null, null],
    ["Panettone", "/products/panettone", null, null, null, null],
    ["Pino Mugo", "/products/pino-mugo", null, null, null, null],
    ["Pompelmo & Calicanto", "/products/diessenza-pompelmo-calicanto", null, null, null, null],
    ["Salted Caramel (Caramello Salato)", "/products/salted-caramel", null, null, null, null],
    ["Tobacco & Vanilla (Tabacco & Vaniglia)", "/products/tobacco-vanilla-tabacco-vaniglia", false, true, true, true],
    ["Velvet Fruit", "/products/fragranza-per-candele-velvet-fruit-per-soia-e-paraffina", null, null, null, null],
    ["Very Vanilla", "/products/very-vanilla", null, null, null, null],
    ["Ylang & Tuberose (Ylang & Tuberosa)", "/products/ylang-tuberose", null, null, null, null],
    ["Zagara e Gelsomino", "/products/zagara-e-gelsomino", null, null, null, null],

  ];

  function ufiCell(val) {
    if (val === null) return '<td class="ufi-cell"><span class="fufi-badge fufi-badge-pending">&#8212;</span></td>';
    return val
      ? '<td class="ufi-cell"><span class="fufi-badge fufi-badge-ufi">&#9888; UFI</span></td>'
      : '<td class="ufi-cell"><span class="fufi-badge fufi-badge-ok">&#10003; UFI Free</span></td>';
  }

  function buildTable() {
    var tbody = document.getElementById('fufi-table-body');
    if (!tbody) return;
    tbody.innerHTML = fragranze.map(function(f) {
      return '<tr data-name="' + f[0].toLowerCase() + '">' +
        '<td class="fragrance-name"><a href="' + f[1] + '">' + f[0] + '</a></td>' +
        ufiCell(f[2]) + ufiCell(f[3]) + ufiCell(f[4]) + ufiCell(f[5]) +
        '</tr>';
    }).join('');
    updateCount(fragranze.length);
  }

  function updateCount(n) {
    var label = document.getElementById('fufi-count-label');
    if (label) label.textContent = n + ' fragranz' + (n === 1 ? 'a' : 'e');
  }

  function applySearch() {
    var q = document.getElementById('fufi-search-input').value.toLowerCase();
    var rows = document.querySelectorAll('#fufi-table-body tr');
    var visible = 0;
    rows.forEach(function(row) {
      if (row.dataset.name.includes(q)) {
        row.classList.remove('hidden-row');
        visible++;
      } else {
        row.classList.add('hidden-row');
      }
    });
    updateCount(visible);
  }

  buildTable();

  var searchInput = document.getElementById('fufi-search-input');
  if (searchInput) searchInput.addEventListener('input', applySearch);

});